import { FC } from "react"
import { Translate } from "../../../../../../../../constant/Translate"
import { ItemInput } from "../../../../../../../../_webui/layout/components/Form/Item/Input"

const { TEXT_T210 } = Translate

export const CollapseAccommodation: FC = () => (
  <ItemInput label={TEXT_T210} maxLength={200} name="lodgingName" />
)
